<template>
	<div id="app">
		<router-view id="mainContainer"></router-view>
	</div>
</template>

<script>
	import axios from '@/http/index'
	export default {
		name: 'App',
	}
</script>
<style type="text/css">
	#app {
		
	}
</style>